import type { ValidatedStepAction } from '@trafilea/tss-lib-funnel-schema-ts';
import type { ActionConfig, RuntimeStepAction } from '../types';

/**
 * Normalize a canonical listener-reaction action (ADR 0004 R16) into the runtime
 * `RuntimeStepAction` that ActionExecutor executes, so a reaction runs through
 * the SAME action logic (no duplicated switch).
 *
 * The reaction is validated against `StepListenerReactionSchema` before it
 * reaches here, and the runtime funnel JSON carries the documented config keys
 * (`url`, `event_name`, `endpoint`, `template_id`, …), so the authoring config
 * narrows to the runtime `ActionConfig` view at this single boundary. The
 * deprecated `show_free_gift_popup` type is preserved so ActionExecutor still
 * hard-rejects it.
 */
export function toRuntimeStepAction(
  action: ValidatedStepAction,
  fallbackId: string,
): RuntimeStepAction {
  const base = {
    id: action.id ?? fallbackId,
    label: action.label ?? '',
    config: (action.config ?? {}) as ActionConfig,
  };

  if (action.type === 'show_free_gift_popup') {
    return { ...base, type: 'show_free_gift_popup' };
  }

  return { ...base, type: action.type };
}
